<template>
	<!-- Product Snapshot -->
	<modal
		class="verification-modal"
		@close="close"
        :size='"large"'
		v-if="selectedSubmission">
		<template slot="header">
			<h3><b>{{ $t('Product Snapshot') }}</b></h3>
		</template>
		<template slot="body">
			<div class="alert alert-warning" v-if="isOrderNotfound">
				<i class="bi bi-exclamation-diamond-fill"></i> Gagal mendapatkan data produk <span v-if="!isSourceOstock">dari OrderOnline</span>
			</div>
			<div class="d-flex justify-content-center" v-if="isFetching">
				<div class="spinner-border" role="status">
					<span class="sr-only">Loading...</span>
				</div>
			</div>
			<div class="product" v-if="order">
				<div class="row" v-for="(product, index) in products" :key="index">
					<div class="col-md-4">
						<img class="rounded shadow-sm" style="max-height: 250px;" :src="product.picture" alt="Product Image">
					</div>
					<div class="col-md-8">
						<div class="text-bold h4 mb-3">{{ product.name }}</div>
						<div>
							<b>Tipe Produk : {{ product.type == 'simple' ? 'Simple' : 'Variant' }}</b>
						</div>
						<div v-if="isSourceOstock">
							SKU : {{ productCode(product) }}
						</div>
						<div class="simple" v-if="product.type === 'simple'">
							<div v-if="!isSourceOstock">
								<span>Harga Coret : {{ formatMoney(product.original_price) }}</span>
							</div>
							<div>
								<span>Harga Supplier : {{ formatMoney(product.original_base_price) }}</span>
							</div>
							<div v-if="!isSourceOstock">
								<span>Harga Seller : {{ formatMoney(getSimpleSellerPrice(product)) }}</span>
							</div>
							<div v-if="!isSourceOstock">
								<span>PSF: {{ formatMoney(getSimpleProductSourcingFee(product)) }}  <i v-tooltip="`5 Persen dari Harga Seller`" class="material-icons" style="font-size: 15px;">info</i></span>
							</div>
							<hr>
						</div>
						<div class="variations" v-if="product.type === 'variable'">
							<table class="table table-bordered">
								<thead>
									<tr>
										<th class="text-center align-middle">Variasi</th>
										<th v-if="!isSourceOstock" class="text-center">Harga Coret</th>
										<th class="text-center">Harga Supplier</th>
										<th v-if="!isSourceOstock" class="text-center">Harga Seller</th>
										<th v-if="!isSourceOstock" class="text-center align-middle">PSF <i v-tooltip="`5 Persen dari Harga Seller`" class="material-icons text-sm">info</i></th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(variation, index) in product.variations.prices" :key="index">
										<td>{{ displayVariationName(variation.name) }}</td>
										<td v-if="!isSourceOstock">{{ formatMoney(variation.original_price) }}</td>
										<td>{{ formatMoney(variation.original_base_price) }}</td>
										<td v-if="!isSourceOstock">{{ formatMoney(variation.price) }}</td>
										<td v-if="!isSourceOstock">{{ formatMoney(calculateProductSourcingFee(variation.price)) }}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<!-- <div v-if="!isSourceOstock">
							<span>Komisi : {{ getCommissionValueFormated(product) }}</span>
						</div> -->
						<div v-if="product.checkout_url" class="mt-2">
							<a
								class="btn btn-light btn-icon"
								:href="product.checkout_url"
								target="_blank"
								v-tooltip="product.checkout_url">
								<i class="material-icons">launch</i>
								<span>{{ $t('View Checkout Page') }}</span>
							</a>
						</div>
					</div>
					<div class="col-md-12">
						<hr>
					</div>
				</div>
				<div class="alert alert-info mt-4">
					Data produk ini sesuai dengan tanggal order pada <span class="text-bold">{{ formatDateLocal(order.created_at) }}</span>
				</div>
			</div>
		</template>
		<template slot="footer">
			<button
				class="btn btn-light"
				@click="close">
					{{ $t('Close') }}
			</button>
		</template>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import ordersOo from '@/api/orders-oo';
import submissionsApi from '@/api/submissions';
import {
	getAxiosErrorMessage,
	getCommissionValueFormated,
	formatDate,
	calculateProductSourcingFee,
	checkSalePrice,
} from '@/lib/helper';

export default {
	name: 'ModalProductSnapshot',
	components: {
		Modal,
	},
	props: {
		selectedSubmission: {
			type: Object,
			default: null,
		},
		dataSource: {
			type: String,
			default: 'oo', // oo for admin, ostock for supplier
		},
	},
	data() {
		return {
			isFetching: true,
			order: null,
			isOrderNotfound: false,
		};
	},
	methods: {
		close() {
			this.$emit('close');
		},
		fetchOrderDetail() {
			if (this.submission !== null) {
				this.isFetching = true;
				const id = this.isSourceOstock ? this.selectedSubmission._id : this.selectedSubmission.source_id;
				const callback = (response) => {
					const data = response.data;
					this.order = data;
					this.isOrderNotfound = false;
					this.isFetching = false;
				};
				const errorCallback = (e) => {
					const message = getAxiosErrorMessage(e);
					console.log(message);
					this.isOrderNotfound = true;
					this.isFetching = false;
				};
				if (this.isSourceOstock) {
					submissionsApi.getOrderDetails(id, callback, errorCallback);
				} else {
					ordersOo.getOrderDetails(id, callback, errorCallback);
				}
			}
		},
		formatDateLocal(createdAt) {
			const dateFormatted = formatDate(this.moment, createdAt, 'DD-MM-YYYY HH:mm');
			// return `${date.format('DD-MM-YYYY')} at ${date.format('HH:mm:ss')}`;
			return dateFormatted;
		},
		displayVariationName(name) {
			return name.replace(/\|\|/g, ' - ');
		},
		getCommissionValueFormated,
		calculateProductSourcingFee,
		getSimpleSellerPrice(product) {
			return checkSalePrice(product?.price, product?.sale_price, this.selectedSubmission?.created_at);
		},
		getSimpleProductSourcingFee(product) {
			return calculateProductSourcingFee(this.getSimpleSellerPrice(product));
		},
		productCode(product) {
			return (this.order.type === 'form') ? product?.code : product?.product_code;
		},
	},
	mounted() {
		this.fetchOrderDetail();
	},
	computed: {
		productData() {
			const order = this.order;
			let product = null;

			if (order.type === 'form') {
				product = order.product_data;
			} else if (order.type === 'storefront') {
				product = order.products[0];
			}

			return product;
		},
		products() {
			const order = this.order;
			let products = [];

			if (order.type === 'storefront' && order.products) {
				products = order.products;
			} else if (order.type === 'form') {
				products.push(order.product_data);
			}

			return products;
		},
		isSourceOstock() {
			return this.dataSource === 'ostock';
		},
	},
};
</script>

<style lang="scss" scoped>
thead {
	border-bottom: 1px solid #DEE2E6;

	.text-sm {
		font-size: 20px;
	}
}
</style>
